import MaterialIcon from '@material/react-material-icon';
import * as React from 'react';
import { AppContext, AppProviderDispatch } from '../../../shared/app-context';
import * as styles from '../report.module.scss';
import { CustomView } from './useCustomViews';
import { Scrollbars } from 'react-custom-scrollbars';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

interface Props {
  customViews: CustomView[];
  activeCustomView?: any;
  showCustomView: (viewname?: string) => void;
}

const useStyles = makeStyles({
  buttonStyle: {
    paddingLeft: 0,
    border: 0,
    background: 'none'
  }
});

/**
 * Display the list of all public views not created by the current user
 */
const OtherViewList = ({ customViews, activeCustomView, showCustomView }: Props) => {
  const { state } = React.useContext<AppProviderDispatch>(AppContext);
  const defaultExists = customViews.find((view) => view.isDefault) !== undefined;
  const publicViews = customViews.filter((view) => view.isPublic && view.ownerEmail !== state.email.toLowerCase());
  const classes = useStyles();

  return (
    <Scrollbars autoHide>
      <button
        className={clsx(activeCustomView ? styles.viewName : styles.activeView, classes.buttonStyle)}
        onClick={() => showCustomView()}
      >
        <span className={styles.otherViewName}>
          {!defaultExists && <MaterialIcon title="Default" icon="insert_chart" />}
          <span>Original {!defaultExists && ' (default)'}</span>
        </span>
      </button>
      {publicViews.length > 0 &&
        publicViews.map((view) => {
          const activeViewName = activeCustomView ? activeCustomView.getName() : '';
          const isActiveView = view.name === activeViewName;
          return (
            <button
              key={view.name}
              className={clsx(isActiveView ? styles.activeView : styles.viewName, classes.buttonStyle)}
              onClick={() => showCustomView(view.name)}
            >
              <span className={styles.otherViewName}>
                {view.isDefault && <MaterialIcon title="Default" icon="insert_chart" />}
                <span>
                  {view.name}
                  {view.isDefault && ' (default)'}
                </span>
              </span>
              <span className={styles.otherViewOwner}>{view.ownerName}</span>
            </button>
          );
        })}
    </Scrollbars>
  );
};

export default OtherViewList;
